import { render, staticRenderFns } from "./KMenu.vue?vue&type=template&id=2ce7538e&scoped=true&"
import script from "./KMenu.vue?vue&type=script&lang=ts&"
export * from "./KMenu.vue?vue&type=script&lang=ts&"
import style0 from "./KMenu.vue?vue&type=style&index=0&id=2ce7538e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce7538e",
  null
  
)

export default component.exports